import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import {
  CHANGE_DATA_ARCHITECTURE,
  CHANGE_DATA_EQUIPMENT,
  CHANGE_DATA_FIREEQUIPMENT,
} from "./Word";

// 🎀 共通ロジックをまとめるhooks
const useSelectValue = (storeKey, actionType, key) => {
  const { b: building, page } = useParams();
  const value = useSelector(
    (state) => state[storeKey]?.[building]?.[page]?.[key]
  );
  const dispatch = useDispatch();

  const change = (val) => {
    dispatch({
      type: actionType,
      payload: { [key]: val },
      bulding: building,
      page,
    });
  };

  return { value, change };
};

// 🎀 ベースのセレクトコンポーネント
const BaseInputSelect = ({ storeKey, actionType, key_num, items }) => {
  const { value, change } = useSelectValue(storeKey, actionType, key_num);

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <Select
        value={value}
        onChange={(e) => change(e.target.value)}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
      >
        {items.map((item, index) => (
          <MenuItem key={index} value={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

// 🎀 各用途に応じたセレクトコンポーネントをエクスポート
export const InputSelect = React.memo((props) => (
  <BaseInputSelect
    {...props}
    storeKey="Architecture"
    actionType={CHANGE_DATA_ARCHITECTURE}
  />
));

export const InputSelectEquip = React.memo((props) => (
  <BaseInputSelect
    {...props}
    storeKey="Equipment"
    actionType={CHANGE_DATA_EQUIPMENT}
  />
));

export const InputSelectFireEquip = React.memo((props) => (
  <BaseInputSelect
    {...props}
    storeKey="FireEquipment"
    actionType={CHANGE_DATA_FIREEQUIPMENT}
  />
));
